import { FunctionComponent } from 'react'

import { ErrorLayout } from 'layout/ErrorLayout'

import { Message } from '../../styled/message'

export const NotFound: FunctionComponent = () => (
  <ErrorLayout>
    <h1>404</h1>
    <Message>{`Woops, the page you're looking for does not exist`}</Message>
  </ErrorLayout>
)
